<template>
  <v-row class="customer-detail custom-border-to contact-wrapper">
    <v-col md="12" sm="12" class="pt-0 d-flex flex-column">
      <v-skeleton-loader
        class="custom-skeleton"
        v-if="pageLoading"
        type="table-tbody"
      >
      </v-skeleton-loader>
      <v-simple-table v-else class="simple-table">
        <template v-slot:default>
          <thead>
            <tr style="background-color: #f3f6f9; color: #24326d">
              <td style="width: 60px !important">
                <v-checkbox
                  :input-value="selectedAll"
                  @change="toggleSelectAll"
                  class="hide-margin py-0 my-0"
                  color="cyan"
                  dense
                  hide-details
                ></v-checkbox>
              </td>
              <td
                style="width: 60px !important"
                class="font-size-13 text-uppercase font-weight-500"
              >
                Status
                <!-- Active / In-Active -->
              </td>
              <td class="font-size-13 text-uppercase font-weight-500">Name</td>
              <!--  <td class="font-size-15 font-weight-600">Last Name</td> -->
              <td class="font-size-13 text-uppercase font-weight-500">
                Display Name
              </td>
              <td class="font-size-13 text-uppercase font-weight-500">
                Email Address
              </td>
              <td class="font-size-13 text-uppercase font-weight-500">
                Mobile Number
              </td>
              <td class="font-size-13 text-uppercase font-weight-500">
                <template v-if="customer.company_type == 'company'"
                  >DID</template
                >
                <template v-if="customer.company_type == 'personal'"
                  >Landline Number</template
                >
              </td>
              <td class="font-size-13 text-uppercase font-weight-500">
                Position
              </td>
              <!-- <td class="font-size-15 font-weight-600">Default</td>
              <td class="font-size-15 font-weight-600">Status</td> -->
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(person, index) in rowData"
              :key="index"
              :class="{
                'custom-border-top': index == 0,
                'orange_lighten-5': index % 2 == 0,
              }"
            >
              <td style="width: 60px !important">
                <v-checkbox
                  :input-value="isPersonSelected(person.id)"
                  @change="togglePersonSelection(person.id, $event)"
                  class="hide-margin"
                  color="cyan"
                  dense
                  hide-details
                ></v-checkbox>
              </td>
              <td
                link
                v-on:click="selectCustomer(person.id)"
                class="font-size-14 font-weight-500"
              >
                <div
                  style="width: 60px !important"
                  v-on:click.prevent.stop="activeInactive(person)"
                >
                  <v-switch
                    :disabled="person.default == 1 || customer.activated == 0"
                    v-model="person.activated"
                    class="mt-0"
                    inset
                    v-on:click.prevent.stop="activeInactive(person)"
                    color="green"
                  ></v-switch>
                </div>
              </td>
              <td
                link
                v-on:click="selectCustomer(person.id)"
                class="font-size-14 font-weight-500 text-capitalize"
              >
                {{ person.title }}. {{ person.first_name }}
                <template v-if="person && person.last_name">
                  {{ person.last_name }}
                </template>
                <div>
                  <v-chip
                    small
                    color="blue white--text"
                    label
                    class=""
                    v-if="person.default == 1"
                  >
                    <span class="font-size-16 font-weight-500"> Primary </span>
                  </v-chip>
                </div>
              </td>
              <!--  <td
                link
                v-on:click="selectCustomer(person.id)"
                class="font-size-14 font-weight-500"
              >
                {{ person.first_name }}
              </td>
              <td
                link
                v-on:click="selectCustomer(person.id)"
                class="font-size-14 font-weight-500"
              >
                {{ person.last_name }}
              </td> -->
              <td
                link
                v-on:click="selectCustomer(person.id)"
                class="font-size-14 font-weight-500"
              >
                <template v-if="person && person.display_name">
                  {{ person.display_name }}
                </template>
                <em v-else class="text-muted"> no display name </em>
              </td>
              <td
                link
                v-on:click="selectCustomer(person.id)"
                class="font-size-14 font-weight-500 text-lowercase"
              >
                <template v-if="person && person.primary_email">
                  <v-icon small class="me-1">mdi-email</v-icon
                  >{{ person.primary_email }}
                </template>
                <em v-else class="text-muted"> no email address </em>
              </td>
              <td
                link
                v-on:click="selectCustomer(person.id)"
                class="font-size-14 font-weight-500"
              >
                <template v-if="person && person.primary_phone">
                  <v-icon small>mdi-phone</v-icon>{{ person.primary_phone }}
                </template>
                <em v-else class="text-muted"> no number</em>
              </td>
              <td
                link
                v-on:click="selectCustomer(person.id)"
                class="font-size-14 font-weight-500"
              >
                <template v-if="person && person.did">
                  {{ person.did }}
                </template>
                <em v-else class="text-muted">
                  no
                  {{ customer?.company_type == "company" ? "did" : "landline" }}
                </em>
              </td>
              <td
                link
                v-on:click="selectCustomer(person.id)"
                class="font-size-14 font-weight-500"
              >
                <template v-if="person && person.designation">
                  {{ person.designation }}
                </template>
                <em v-else class="text-muted"> no position</em>
              </td>
              <!-- <td class="font-size-14 font-weight-500">
                <Default :status="person.default"></Default>
              </td>
              <td class="font-size-14 font-weight-500">
                <Status :status="person.activated"></Status>
              </td> -->
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <div class="listing-footer-fixed">
        <ListingFooter
          :dataLoading="searching"
          :showingFrom="showingFrom"
          :showingTo="showingTo"
          :totalRows="totalRows"
          :currentPage="currentPage"
          :totalPages="totalPages"
          removePage
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
// import Status from "@/view/pages/partials/Status.vue";
// import Default from "@/view/pages/partials/Default.vue";
import { PATCH } from "@/core/services/store/request.module";
import { ErrorEventBus } from "@/core/lib/message.lib";
import { QUERY } from "@/core/services/store/request.module";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import { PaginationEventBus } from "@/core/lib/pagination.lib";

export default {
  name: "contact-persons",
  title: "Customer",
  mixins: [CommonMixin],
  props: {
    customer: {
      type: Object,
      required: true,
      default: function () {
        return {};
      },
    },
    pageLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      rowData: [],
      selectedRows: [],

      searching: false,
      currentPage: 1,
      totalRows: 0,
      totalPages: 1,
      perPage: 20,
      rowsOffset: 0,
    };
  },
  components: {
    // Status,
    // Default,
    ListingFooter,
  },
  watch: {
    customer: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val && val.id) {
          this.currentPage = 1;
          this.getPersons();
        }
      },
    },

    selectedRows(param) {
      this.$emit("selectedRows", param);
    },
  },
  methods: {
    getPersons() {
      if (!this.customer.id) return;

      this.searching = true;

      this.$store
        .dispatch(QUERY, {
          url: `customer/${this.customer.id}/contact-person`,
          data: {
            current_page: this.currentPage,
            per_page: this.perPage,
          },
        })
        .then(({ data }) => {
          this.rowData = data.rows || [];
          this.totalRows = data.total_rows || 0;
          this.currentPage = data.current_page || 1;
          this.perPage = data.per_page || 15;
          this.rowsOffset = data.offset || 0;
          this.totalPages = Math.max(
            1,
            data.total_pages || Math.ceil(this.totalRows / this.perPage)
          );
          this.selectedRows = this.selectedRows.filter((id) =>
            this.rowData.some((person) => person.id === id)
          );
        })
        .finally(() => {
          this.searching = false;
        });
    },
    isPersonSelected(personId) {
      return this.selectedRows.includes(personId);
    },
    togglePersonSelection(personId, checked) {
      if (checked) {
        if (!this.selectedRows.includes(personId)) {
          this.selectedRows.push(personId);
        }
      } else {
        this.selectedRows = this.selectedRows.filter((id) => id !== personId);
      }
    },
    toggleSelectAll(checked) {
      if (checked) {
        this.selectedRows = this.rowData.map((person) => person.id);
      } else {
        this.selectedRows = [];
      }
    },
    selectCustomer(param) {
      this.$emit("selectCustomer", param);
    },
    assignData() {
      const _this = this;
      if (_this.lodash.isEmpty(_this.customer.persons) === false) {
        _this.rowData = _this.customer.persons;
      }
    },
    activeInactive(data) {
      if (this.customer.activated == 0) {
        return false;
      }
      if (data.default == 1) {
        ErrorEventBus.$emit(
          "update:error",
          "The Primary Contact Person can’t be In-Active."
        );
        return false;
      }

      const _this = this;
      if (data.activated == false) {
        data.activated = 0;
      } else {
        data.activated = 1;
      }
      _this.$store
        .dispatch(PATCH, {
          url: `single-person/${data.activated}/${data.id}`,
          data: {
            id: data.id,
            status: data.activated,
          },
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {});
    },
  },
  mounted() {
    this.getPersons();

    PaginationEventBus.$on("update:pagination", (page) => {
      this.currentPage = page;
      this.getPersons();
    });

    this.$root.$on("clearSelection", () => {
      this.selectedRows = [];
    });
  },
  beforeDestroy() {
    PaginationEventBus.$off("update:pagination");
    this.$root.$off("clearSelection");
  },
  computed: {
    selectedAll() {
      const totalItems = this.rowData.length;
      return totalItems > 0 ? this.selectedRows.length === totalItems : false;
    },
    showingFrom() {
      return this.rowData.length ? this.rowsOffset + 1 : 0;
    },

    showingTo() {
      return this.rowsOffset + this.rowData.length;
    },
  },
};
</script>
<style scoped>
.listing-footer-fixed {
  position: fixed;
  bottom: 0;
  left: 500px;
  right: 0;
  background: #fff;
  z-index: 100;
}
</style>
